/**
 * Normalizes submission data by converting empty strings to null for optional fields.
 * Backend validation expects null instead of empty strings for optional fields.
 *
 * @param data - The data object to normalize
 * @returns Normalized data with empty strings converted to null
 */
export function normalizeSubmissionData<T extends Record<string, unknown>>(
  data: T,
): T {
  const normalized: Record<string, unknown> = { ...data };

  const optionalStringFields = [
    'stock_ratio',
    'incoming_stock_ratio',
    'comments',
  ] as const;

  const optionalDateFields = [
    'earliest_IHD_date_to_deliver_stock',
    'incoming_stock_date',
  ] as const;

  optionalStringFields.forEach((field) => {
    if (field in normalized && normalized[field] === '') {
      normalized[field] = null;
    }
  });

  optionalDateFields.forEach((field) => {
    if (field in normalized && normalized[field] === '') {
      normalized[field] = null;
    }
  });

  return normalized as T;
}
